import { useState } from 'react'
import { env } from './EnvironmentVariables'
import { app_latest_version, links } from '../services/Constants'
import semver from 'semver'
import { persistent } from './LocalStorage'
import ElectronIPC from './ElectronIPC'
import { getProcessArchitecture, stripSemverVersion } from '../utils'

function useAppUpdateService() {
    const [showUpdateNotification, set_showUpdateNotification] = useState<{ from: string; to: string } | null>(null)
    const [isUpdateAvailable, set_isUpdateAvailable] = useState<{ from: string; to: string } | null>(null)

    const checkForUpdate = () => {
        if (!env.IS_ELECTRON) {
            // if browser session, then app updates are meaningless.
            return
        }

        const currentVersion = stripSemverVersion(env.APP_VERSION) || '0.0.0'

        console.log(`checkForUpdate: latestVersion=${app_latest_version} currentVersion=${currentVersion}`)
        if (!semver.valid(app_latest_version) || !semver.valid(currentVersion)) {
            return
        }
        if (app_latest_version)
            if (semver.gt(app_latest_version, currentVersion)) {
                console.log(`checkForUpdate: latestVersion=${app_latest_version} > currentVersion=${currentVersion}`)
                const appUpdateNotificationSuppresedVersion =
                    persistent.getString('appUpdateNotificationSuppresedVersion') || '0.0.0'
                console.log(
                    `checkForUpdate: appUpdateNotificationSuppresedVersion=${appUpdateNotificationSuppresedVersion}`
                )
                if (semver.gt(app_latest_version, appUpdateNotificationSuppresedVersion)) {
                    console.log(
                        `checkForUpdate: app_latest_version=${app_latest_version} > ` +
                            `appUpdateNotificationSuppresedVersion=${appUpdateNotificationSuppresedVersion}.` +
                            `Showing app update notification.`
                    )

                    // show update notification
                    set_showUpdateNotification({ from: currentVersion, to: app_latest_version })
                }

                set_isUpdateAvailable({ from: currentVersion, to: app_latest_version })
            }
    }

    const closeUpdateNotification = ({ dontAskAgainForThisVersion }: { dontAskAgainForThisVersion: boolean }) => {
        set_showUpdateNotification(null)
        if (dontAskAgainForThisVersion) {
            persistent.set('appUpdateNotificationSuppresedVersion', app_latest_version)
        }
    }

    const runAppUpdate = async () => {
        let downloadUrl = ''
        if (env.OS === 'darwin') {
            const architecture = await getProcessArchitecture()
            if (architecture === 'arm') {
                downloadUrl = links.app_download_link_darwin_arm64
            } else {
                downloadUrl = links.app_download_link_darwin
            }
        } else if (env.OS === 'win32') {
            downloadUrl = links.app_download_link_win32
        }

        downloadUrl = downloadUrl.replace('latest', app_latest_version)

        // In the future, download and open the installer in-app
        // let downloadPath = await ElectronIPC.getPath('downloads')
        // ElectronIPC.downloadFile(downloadUrl, null, 'show-in-folder', downloadPath)

        if (downloadUrl) {
            ElectronIPC.openLinkInBrowser(downloadUrl)
        }
    }

    return {
        checkForUpdate,
        isUpdateAvailable,
        showUpdateNotification,
        closeUpdateNotification,
        runAppUpdate,
    }
}

export default useAppUpdateService
